/** action types */
export const CHANGE_FEEDBACK_INPUT = 'ProductDetails::Feedback::ChangeFeedbackData';
export const SET_FEEDBACK_RATING = 'ProductDetails::Feedback::SetFeedbackRating';
export const SUBMIT_FEEDBACK = 'ProductDetails::Feedback::SubmitFeedback';
export const SUBMIT_FEEDBACK_SUCCESS = 'ProductDetails::Feedback::SubmitFeedbackSuccess';
export const SUBMIT_FEEDBACK_ERROR = 'ProductDetails::Feedback::SubmitFeedbackError';
export const RATE_FEEDBACK = 'ProductDetails::Feedback::RateFeedback';
export const FETCH_FEEDBACK_REQUEST = 'ProductDetails::Feedback::FetchFeedbackRequest';
export const FETCH_FEEDBACK_SUCCESS = 'ProductDetails::Feedback::FetchFeedbackSuccess';
export const FETCH_FEEDBACK_ERROR = 'ProductDetails::Feedback::FetchFeedbackError';

/** feedback status list */
export const FEEDBACK_STATUS_INITIAL = null;
export const FEEDBACK_STATUS_SUCCESS = 'success';
export const FEEDBACK_STATUS_ERROR = 'error';
export const FEEDBACK_STATUS_VALIDATION = 'validation';

export const FeedbackValidatedFields = ['Rating', 'Name', 'Email', 'Comment'];
export const FEEDBACK_FETCH_LIMIT = 5;

/** changeusefullness api constants */
export const USEFULLNESS_LIKE = 0;
export const USEFULLNESS_DISLIKE = 1;

/** sortBy values, must be strings due to how Dropdown is implemented, 0 is considered falsy */
export const FEEDBACK_SORT_BY_DATE = '0';
export const FEEDBACK_SORT_BY_RATING = '1';
export const FEEDBACK_SORT_BY_USEFULNESS = '2';

export const FeedbackSortByOptions = [
  {
    label: 'По дате публикации',
    slug: FEEDBACK_SORT_BY_DATE,
  },
  {
    label: 'По рейтингу',
    slug: FEEDBACK_SORT_BY_RATING,
  },
  {
    label: 'По популярности отзыва',
    slug: FEEDBACK_SORT_BY_USEFULNESS,
  },
];
